import { RawIconBase, type RawIconProps } from './icons/RawIconBase';

// Threads 2026 app icon.
export function ThreadsIcon(props: RawIconProps) {
  return (
    <RawIconBase color="#000000" viewBox="0 0 24 24" {...props}>
      <path d="M6.234 0h11.531c3.441 0 6.234 2.789 6.234 6.234v11.531c0 3.441-2.789 6.234-6.234 6.234H6.234C2.789 24 0 21.211 0 17.766V6.234C0 2.789 2.789 0 6.234 0z" />
      <path
        fill="white"
        d="M16.697 11.32c-.023-2.616-1.439-4.191-3.834-4.191c-1.598 0-2.944 .722-3.647 1.875l1.547 1.078c.403-.633 .956-1.158 1.969-1.158c1.148 0 1.739 .637 1.908 1.823c-.553-.084-1.106-.131-1.678-.131c-3.094 0-4.552 1.402-4.552 3.253c0 1.884 1.458 2.995 3.605 2.995c2.353 0 3.759-1.589 4.336-3.553c.6 .272 1.013 .905 1.013 1.852c0 2.541-2.93 3.923-5.414 3.923c-3.666 0-6.061-2.405-6.061-6.319c0-4.795 3.169-7.866 7.425-7.866c2.859 0 4.27 1.252 5.231 2.934l1.58-1.106C19.083 4.556 16.748 3 13.247 3c-5.578 0-9.375 3.961-9.375 9.703c0 5.25 3.717 8.302 8.142 8.302c3.661 0 7.359-2.133 7.359-5.789C19.373 13.303 18.281 12.038 16.697 11.32L16.697 11.32zM11.948 14.962c-.806 0-1.519-.384-1.519-1.092c0-1.111 1.369-1.453 2.705-1.453c.506 0 1.003 .033 1.444 .131C14.264 13.997 13.327 14.962 11.948 14.962L11.948 14.962z"
      />
    </RawIconBase>
  );
}
